export const commonsamples = [
    {
        id:0,
        chatname:"Check Grammar",
        promptsandresponses:[
            {
             id:1,
             prompt:"I were there.",
             response:"I was there."
            },
        ]
    },
    {
        id:1,
        chatname:"Extract Keywords",
        promptsandresponses:[
            {
             id:1,
             prompt:"Electric cars have been around for quite some time, but it is only in recent years that they have become more popular. With the increasing concern about the environment and global warming, many people are now considering electric cars as an alternative to traditional gasoline-powered cars. One of the main advantages of electric cars is that they produce zero emissions. This means that they do not emit harmful gases into the atmosphere, which is good news for our planet. In addition, they are much quieter than traditional cars, making them a great choice for city driving.",

             response:"Electric cars, environment, global warming, alternative, gasoline-powered cars, zero emissions, harmful gases, atmosphere, planet, quieter, city driving."
            },
        ]
    },
    {
        id:2,
        chatname:"Summary",
        promptsandresponses:[
            {
             id:1,
             prompt:"Electric cars have been around for quite some time, but it is only in recent years that they have become more popular. With the increasing concern about the environment and global warming, many people are now considering electric cars as an alternative to traditional gasoline-powered cars. One of the main advantages of electric cars is that they produce zero emissions. This means that they do not emit harmful gases into the atmosphere, which is good news for our planet. In addition, they are much quieter than traditional cars, making them a great choice for city driving.",

             response:"Electric cars are gaining popularity due to the growing concern about the environment and global warming. They produce zero emissions and are much quieter than traditional cars, making them a great option for city driving."
            },
        ]
    },
    {
        id:3,
        chatname:"Compact",
        promptsandresponses:[
            {
             id:1,
             prompt:"Electric cars have been around for quite some time, but it is only in recent years that they have become more popular. With the increasing concern about the environment and global warming, many people are now considering electric cars as an alternative to traditional gasoline-powered cars. One of the main advantages of electric cars is that they produce zero emissions. This means that they do not emit harmful gases into the atmosphere, which is good news for our planet. In addition, they are much quieter than traditional cars, making them a great choice for city driving.",

             response:"Electric cars have become more popular due to environmental concerns. They produce zero emissions, making them a great choice for city driving."
            },
        ]
    },
    {
        id:4,
        chatname:"Description",
        promptsandresponses:[
            {
             id:1,
             prompt:"leather bag, brown, under $29",

             response:`The leather bag is a stylish and functional accessory that is perfect for any occasion. Made from high-quality brown leather, this bag is durable and designed to last. It features a spacious main compartment that can hold all of your essentials, including your phone, wallet, keys, and more. The bag has a simple yet elegant design, with a single shoulder strap that makes it easy to carry. It is lightweight and comfortable, and the adjustable strap ensures a perfect fit for any body type.
             Best of all, this leather bag is available for under $29, making it an affordable option for anyone who wants a high-quality bag without breaking the bank. Whether you're running errands, headed to work, or out on the town, this leather bag is the perfect accessory to complete your look.`
            },
        ]
    },
    {
        id:5,
        chatname:"Email",
        promptsandresponses:[
            {
             id:1,
             prompt:"Parents-teacher conference, 12:30 Wednesday, Sender: Tom",

             response:`Subject: Reminder - Parents-teachers conference, 12:30 Wednesday
             \n\nDear Parents,\n\nI hope this email finds you well. Just a quick reminder that we have the parents-teachers conference scheduled for 12:30 pm on Wednesday. This conference is a great opportunity for us to discuss your child's progress in school and address any concerns or questions you may have.\
             \nAs you all know, the conference will be held online this year, and you will receive a link to join the conference via email. Please make sure to check your email before the conference starts. If you have any technical difficulties, please do not hesitate to contact me, and I will be happy to assist you. I look forward to meeting with you all and discussing your child's progress in school. We have a lot to talk about, so please come prepared with any questions or concerns that you may have.
             \n\nThank you, and I will see you all on Wednesday.
             \n\nBest regards,
             \n\nTom
             `
            },
        ]
    },
    {
        id:6,
        chatname:"Story",
        promptsandresponses:[
            {
             id:1,
             prompt:"a bird, a dog, sunny day",

             response:`Once upon a sunny day, a bird was perched on a tree branch, singing a melodious tune. The bird was enjoying the warm sunshine and the fresh air. Suddenly, a dog came running towards the tree, barking loudly. The bird got frightened and flew away, but the dog kept chasing it.\nThe bird flew as fast as it could, but the dog was swift and determined. As the chase continued, the bird noticed that the dog wasn't trying to harm it, but rather trying to play. The bird landed on a nearby branch, still afraid but curious. The dog tried to climb up the tree, but it was too high for it.\nThe bird realized that the dog wasn't a threat and decided to play along. It started chirping and fluttering around, inviting the dog to play. The dog was thrilled and wagged its tail happily. The two started chasing each other around the tree, having the time of their lives.
             \nAs the day passed, the sun began to set, and the bird knew it was time to leave. It chirped a goodbye to the dog and flew away. The dog watched it disappear into the horizon, feeling a bit sad, but also happy for the fun they had shared.
             From that day on, the dog would often come to the tree, hoping to see the bird again. Although they never played together again, the memory of that sunny day remained in the dog's heart forever. It was a reminder of the joy that comes from unexpected friendships, and the beauty of nature on a sunny day.`
            },
        ]
    },
    {
        id:7,
        chatname:"Improve",
        promptsandresponses:[
            {
             id:1,
             prompt:"Electric cars are gaining popularity due to the growing concern about the environment and global warming. They produce zero emissions and are much quieter than traditional cars, making them a great option for city driving.",

             response:"Electric vehicles have become increasingly popular due to growing concerns about the environment and global warming. These vehicles produce zero emissions and operate more quietly than traditional cars, making them an ideal choice for city driving."
            },
        ]
    }    

    

]
